/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_Withdraw_WarningInputs */

const en_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawing mandatory consent will require account deletion.`)
};

const de_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Widerrufen der Pflichteinwilligung erfordert die Kontoloeschung.`)
};

const fr_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le retrait du consentement obligatoire necessitera la suppression du compte.`)
};

const es_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revocar el consentimiento obligatorio requerira la eliminacion de la cuenta.`)
};

const it_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La revoca del consenso obbligatorio richiedera l'eliminazione dell'account.`)
};

const nl_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het intrekken van verplichte toestemming vereist het verwijderen van je account.`)
};

const pl_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycofanie obowiazkowej zgody bedzie wymagalo usuniecia konta.`)
};

const fi_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakollisen suostumuksen peruuttaminen edellyttaa tilin poistamista.`)
};

const da_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbagetraekning af obligatorisk samtykke kraever sletning af kontoen.`)
};

const sv_consent_settings_withdraw_warning = /** @type {(inputs: Consent_Settings_Withdraw_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aterkallande av obligatoriskt samtycke kraver radering av kontot.`)
};

/**
* | output |
* | --- |
* | "Withdrawing mandatory consent will require account deletion." |
*
* @param {Consent_Settings_Withdraw_WarningInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_withdraw_warning = /** @type {((inputs?: Consent_Settings_Withdraw_WarningInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_Withdraw_WarningInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_withdraw_warning(inputs)
	if (locale === "fr") return fr_consent_settings_withdraw_warning(inputs)
	if (locale === "es") return es_consent_settings_withdraw_warning(inputs)
	if (locale === "it") return it_consent_settings_withdraw_warning(inputs)
	if (locale === "nl") return nl_consent_settings_withdraw_warning(inputs)
	if (locale === "pl") return pl_consent_settings_withdraw_warning(inputs)
	if (locale === "fi") return fi_consent_settings_withdraw_warning(inputs)
	if (locale === "da") return da_consent_settings_withdraw_warning(inputs)
	if (locale === "sv") return sv_consent_settings_withdraw_warning(inputs)
	return en_consent_settings_withdraw_warning(inputs)
});